import { useEffect, useState } from "react";
import { BookingRequestsStatus } from "../../BookingRequest/typings/booking-requests.types";
import { useRemoteFetchActiveBookingRequests } from "../../../hooks/Remote/BookingRequests/useRemoteFetchActiveBookingRequests";

export const useRequestCount = ({ isRequestAdmin }: { isRequestAdmin: boolean }) => {
  const [requestCount, setRequestCount] = useState(0);

  const { data: remoteActiveBookingRequests } = useRemoteFetchActiveBookingRequests(
    "active",
    isRequestAdmin
  );

  useEffect(() => {
    if (!isRequestAdmin) return;
    if (!remoteActiveBookingRequests) return;
    const requested = remoteActiveBookingRequests.filter(
      req => req.statusData.status === BookingRequestsStatus.REQUESTED
    ).length;
    setRequestCount(requested);
  }, [remoteActiveBookingRequests]);

  return { requestCount };
};
